import { FunnelAttributeConfig } from '../types';

export const FUNNEL_ATTRIBUTES_QUERY_PARAMS = {
  LAST_PAGE_NAME: 'last_page_name',
} as const;

export const FUNNEL_ATTRIBUTES_WHITELIST: FunnelAttributeConfig[] = [
  {
    queryParam: FUNNEL_ATTRIBUTES_QUERY_PARAMS.LAST_PAGE_NAME,
    mapValue: (value) => value.trim() || null,
  },
];
